import * as React from "react";
import { Redirect } from "react-router-dom";

import { ALL_API_KEYS_ROUTE } from "components/router/Routes";

const ApiKeysView = (): JSX.Element => <Redirect to={ALL_API_KEYS_ROUTE.path} />;

export default ApiKeysView;
